/* eslint-disable react/no-danger */
/* eslint react/no-did-mount-set-state: 0 */

import React, {useState, useRef, useEffect} from 'react';
import PropTypes from 'prop-types';
import {MoreOrLess} from '@homeaway/react-collapse';
import EdapViewTracker from '../../components/common/edap-view-tracker/EdapViewTracker';
import {onViewMoreOrLessClick} from './events';

import './styles.less';

const COLLAPSED_TEXT_MAX_HEIGHT = 96;
const MAX_LINE_COUNT = 4;

function SEOIntroductionParagraphComponent(props) {
    const [lineCount, setLineCount] = useState(0);
    const introRef = useRef(null);

    useEffect(() => {
        const {current = {}} = introRef;
        const {clientHeight = 0} = current || {};
        const newLineCount =
            clientHeight > COLLAPSED_TEXT_MAX_HEIGHT ? MAX_LINE_COUNT : 0;

        setLineCount(newLineCount);
    }, [setLineCount, introRef]);

    const {id, labels, introduction, ACTION_LOCATION, content} = props;
    const collapsibleContentProps = {
        lines: lineCount,
        moreText: labels.buttonViewMore,
        lessText: labels.buttonViewLess,
        onExpandedChange: onViewMoreOrLessClick,
    };

    const showMoreLessButton = lineCount > 0 ? collapsibleContentProps : {};

    return content || introduction ? (
        <div className={'seo-introduction-paragraph container module'}>
            <EdapViewTracker
                eventData={{
                    action_location: ACTION_LOCATION,
                    position_fired: 'top',
                }}
                edapEvent={'content_module.presented'}
            />
            {
                <MoreOrLess id={id} expanded={false} {...showMoreLessButton}>
                    <div
                        className="collapsible-content__body-text"
                        ref={introRef}
                    >
                        {introduction}
                    </div>
                </MoreOrLess>
            }
            <EdapViewTracker
                eventData={{
                    action_location: ACTION_LOCATION,
                    position_fired: 'bottom',
                }}
                edapEvent={'content_module.presented'}
            />
        </div>
    ) : null;
}

SEOIntroductionParagraphComponent.propTypes = {
    id: PropTypes.string,
    introduction: PropTypes.string.isRequired,
    labels: PropTypes.shape({
        buttonViewLess: PropTypes.string,
        buttonViewMore: PropTypes.string,
    }),
    ACTION_LOCATION: PropTypes.string,
    isMobile: PropTypes.bool,
};

SEOIntroductionParagraphComponent.defaultProps = {
    id: 'seo-introduction-paragraph-id',
    ACTION_LOCATION: 'collapsible-paragraph',
    isMobile: false,
};

export default SEOIntroductionParagraphComponent;
